export default "__VITE_ASSET__Cd5raQ9A__"